'use client';

import React from 'react';

import { useTreatmentFilterUpdaterContext } from '../TreatmentFilter/context/TreatmentFilterContext';

import Button from '../../../_ui/_blocks/Buttons/Button/Button';
import Typography from '../../../_ui/_blocks/Typography/Typography';

import styles from './SortAndFilterNoResults.module.css';

const SortAndFilterNoResults = () => {
    const { clearAllFilters } = useTreatmentFilterUpdaterContext();

    return (
        <div className="text-center space-y-050">
            <div>
                <Typography as="h5" weight="500">
                    No matching treatments
                </Typography>
                <Typography as="p" size="080">
                    Try changing or removing some of your filters
                </Typography>
            </div>
            <div>
                <Button variant="none" size="small" onClick={clearAllFilters} title="Clear all filters" className={styles.clearAll}>
                    <Typography size="090">Clear all filters</Typography>
                </Button>
            </div>
        </div>
    );
};

export default SortAndFilterNoResults;
